import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router-dom';

// @utility
// import alertText from "./../../../../../@utility/app/alertText";
import loadImagesFetch from "./../../../../../@utility/app/loadImagesFetch";
import { setStorage, removeStorage } from "./../../../../../@utility/app/storage";

// Auth
import { isUserLoggedIn } from "./../../../../../@core/auth/utils";

// Redux
import { setLoadHome } from "./../../../../../@core/redux/actions/app/processing";

// Component
import ContentHome from "./Home/Content";
import ContentCategory from "./Category/Content";
import SnackbarSet from "./../../components/SnackbarSet";
import NotiEvent from "./../../components/NotiEvent";
import SkeletionScreen from "./SkeletionScreen";
import FabWheelSpinIcon from "./Home/FabWheelSpinIcon";

// CSS
import "./Home.css";
import "./Lottery.css";

const HomeApp = ({ agent_setting_menu, pageSelect, checkPageGameList }) => {
    document.title = process.env.REACT_APP_OG_SITE_NAME + " - หน้าหลัก";
    const { random, code } = useParams();
    const { path } = useRouteMatch();
    const childRef = useRef();
    const dispatch = useDispatch();
    const [loadComponent, setLoadComponent] = useState(false);
    const [processing, setProcessing] = useState(false);
    const dataCampAll = useSelector(state => state.reduxGame.itemsCampList);

    useEffect(() => {
        if (loadComponent) {
            let statusLoad = loadImagesFetch(1);
            if (statusLoad) {
                dispatch(setLoadHome(true));
            }
        }
    }, [dispatch, loadComponent]);

    useEffect(() => {
        if (random !== undefined && code !== undefined) {
            let urlPath = path.split('/');

            /* เส้นทางแบบ /:random/affiliate/:code เก็บค่าเหมือน query string
               จึงต้องลบอีกระบบทิ้งด้วยเหตุผลเดียวกัน (ดู VerticalRoutes.js) */

            // เก็บข้อมูลเพื่อนที่เชิญ
            if (urlPath[2] === "affiliate") {
                setStorage("affiliate", code)
                removeStorage("partner")
            }

            // เก็บข้อมูลผู้เชิญเข้าระบบ partner
            if (urlPath[2] === "partner") {
                setStorage("partner", code)
                removeStorage("affiliate")
            }

            // อ้างอิง
            if (urlPath[2] === "refer") {
                setStorage("refer", code)
            } else if (urlPath[2] === "ref") {
                setStorage("refer", code)
            }

            // การตลาด
            if (urlPath[2] === "market") {
                setStorage("market", code)
            }
        }
    }, [random, code])

    return (
        <>
            <div id="HomeApp" className="HomeApp">
                {
                    processing ?
                        pageSelect === "category" ?
                            <ContentCategory
                                isUserLoggedIn={isUserLoggedIn()}
                                dataCampAll={dataCampAll}
                                setting_menu={agent_setting_menu}
                                processing={processing}
                                setProcessing={setProcessing}
                                loadComponent={loadComponent}
                                setLoadComponent={setLoadComponent}
                                checkPageGameList={checkPageGameList}
                            />
                            :
                            <ContentHome
                                isUserLoggedIn={isUserLoggedIn()}
                                dataCampAll={dataCampAll}
                                setting_menu={agent_setting_menu}
                                processing={processing}
                                setProcessing={setProcessing}
                                loadComponent={loadComponent}
                                setLoadComponent={setLoadComponent}
                            />
                        :
                        <SkeletionScreen processing={processing} setProcessing={setProcessing} dataCampAll={dataCampAll}></SkeletionScreen>
                }
            </div>

            <SnackbarSet ref={childRef} />
            <NotiEvent></NotiEvent>

            {
                (processing && isUserLoggedIn()) && (
                    <FabWheelSpinIcon />
                )
            }

        </>
    );
}

export default HomeApp;